import getTextBoxCoordsCanvas from './getTextBoxCoordsCanvas';

export { getTextBoxCoordsCanvas };
